var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8339C9.29833 15.8339 8.59583 15.6855 7.91333 15.4214",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4017 10.3906C15.825 13.3065 12.9125 15.834 10 15.834",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8992 7.43359C16.475 8.10776 16.9867 8.84276 17.4017 9.61026C17.5325 9.85276 17.5325 10.1469 17.4017 10.3894",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16669 15.8327L15.8334 4.16602",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14418 11.8563C7.11918 10.8313 7.11918 9.16875 8.14418 8.14375C9.16918 7.11875 10.8317 7.11875 11.8567 8.14375",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2033 5.79602C12.9141 4.79852 11.4566 4.16602 9.99998 4.16602C7.08748 4.16602 4.17497 6.69352 2.59831 9.61018C2.46747 9.85268 2.46747 10.1468 2.59831 10.3893C3.38664 11.8468 4.50831 13.2068 5.79664 14.2035",
    stroke: "#73737B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.b5179e54.svg";
export { ForwardRef as ReactComponent };